'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var maplibreGl = require('maplibre-gl');
var useResizeObserver = require('@react-hook/resize-observer');
require('./ResizableMap.module.css.js');
var MapMarker = require('./MapMarker.js');
var graphql = require('./graphql.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useResizeObserver__default = /*#__PURE__*/_interopDefaultLegacy(useResizeObserver);

const ResizableMap = ({
  coordinates,
  maptilerKey,
  s = {
    height: '20rem',
    width: '20rem'
  }
}) => {
  const [maplibre, setMaplibre] = React.useState(null);
  const mapContainer = React.useRef(null);
  const mapElement = React.useRef(null);
  const mapMarker = React.useRef(null);
  const {
    lng,
    lat
  } = coordinates;

  // Resize the map whenever the mapElement itself has a different size.
  // This is useful because, in addition to the window resizing, many other
  // events in the page can cause mapElement to resize and we need the map
  // to respond accordingly
  useResizeObserver__default["default"](mapContainer, () => {
    if (maplibre) maplibre.resize();
  });
  React.useEffect(() => {
    if (!mapElement.current) return;
    setMaplibre(new maplibreGl.Map({
      container: mapElement.current,
      style: `https://api.maptiler.com/maps/streets/style.json?key=${maptilerKey}`,
      center: [lng, lat],
      zoom: 15,
      trackResize: false // trackResize only resizes on window resize. This case is covered by useResizeObserver
    }));
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [maptilerKey]);
  React.useEffect(() => {
    if (!(maplibre && mapMarker.current)) return;
    new maplibreGl.Marker(mapMarker.current).setLngLat([lng, lat]).addTo(maplibre);
  }, [maplibre, lng, lat]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: s,
    ref: mapContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: mapElement,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React__default["default"].createElement(MapMarker["default"], {
    ref: mapMarker
  })));
};

exports.maptilerQuery = graphql["default"];
exports["default"] = ResizableMap;
